import { forEach } from "@angular/router/src/utils/collection";

export interface IIndicatorParam {
    name: string;
    value: string;
    type: string;
    color?: string;
    colorArea?: string;
    width?: number;
    array?: string[];
}

export interface IIndicatorDefaults {
    item: IIndicatorParam[];
    basedOn?: string;
}

export interface IIndicator {
    type: string;
    group: string;
    title: string;
    abbreviation: string;
    description: string;
    defaults: IIndicatorDefaults;
}

export interface IIndicators {
    indicator: IIndicator[];
}

export interface IIndicatorsConfig {
    indicators: IIndicators;
}

export var indicatorsSettings = {
    name: "",
    plotIndex: 0,
    defaultSettings: {},
    seriesType: [
        "area",
        "column",
        "jump-line",
        "line",
        "marker",
        "spline",
        "spline-area",
        "step-area",
        "step-line",
        "stick",
        "range-area",
        "candlestick",
        "ohlc"
    ]
};

export interface IIndicatorInstance {
    insance?: anychart.core.stock.indicators.Base;
    enabled?: boolean;
    mapping?: anychart.data.TableMapping;
    title: string;
    selectedHeight?: string;
    indicator: IIndicator;
}

export interface IIndicatorInstances {
    [indicatorType: string]: IIndicatorInstance[];
}

export function getInputLabelText(keyText: string) {
    var text = "";
    var result: string[] = [];

    keyText.split(/(?=[A-Z])/).filter(function(item) {
        if (item.length === 1) {
            text += item;
        } else {
            text += " ";
            text += item;
        }
    });
    text = text.trim();
    text = text[0].toUpperCase() + text.substr(1);

    text.split(" ").filter(function(item, index) {
        if (item.length === 1 && index !== text.split(" ").length - 1) {
            result.push(item + "-");
        } else {
            result.push(item);
        }
    });
    return result.join(" ").replace(/-\s/, "-");
}

export function DeepCopyIndicators(orgin: IIndicatorInstances[]): IIndicatorInstances {
    let res: IIndicatorInstances = {};

    orgin.forEach(org => {
        Object.keys(org).forEach(key => {
            if(org[key] == null || org[key].length < 1) return;
            res[key] = [];
            org[key].forEach(ii => {
                let ind: IIndicator = {
                    type: ii.indicator.type,
                    group: ii.indicator.group,
                    title: ii.indicator.title,

                    abbreviation: ii.indicator.abbreviation,
                    description: ii.indicator.description,
                    defaults: {
                        item: [],
                        basedOn: ii.indicator.defaults.basedOn || "close"
                    }
                };
                ii.indicator.defaults.item.forEach(item => {
                    let newItem: IIndicatorParam = {
                        name: item.name,
                        value: item.value,
                        type: item.type,
                        color: item.color,
                        width: item.width,
                        array: item.array
                    };
                    ind.defaults.item.push(newItem);
                });

                res[key].push({
                    title: ii.title,
                    enabled: ii.enabled,
                    indicator: ind
                });
            });
        });
    });
    return res;
}
